import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FaviconService } from './core/services/favicon.service';
import { environment } from '../environments/environment';
import { AuthenticationService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit{

    constructor(private router: Router, private faviconService: FaviconService, public authService: AuthenticationService) { }

    ngOnInit() {
        this.faviconService.setFavicon(environment.clientID);

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        if (this.authService.getCurrentUser()) {
            this.authService.refreshPermissions().subscribe();
        }
    }
}
